import React, { useState } from "react"
import { useSelector } from "react-redux"
import { Button, Card, Modal } from "antd"
import { TEXT_LANG } from "../../../lib/lang/main"
import { botones } from "../../../lib/global/data"

const ModalPersonalizado = (props) => {
    const {
        slug,
        icon,
        typeView,
        component,
        version,
        title
    } = props
    const pais = useSelector(state => state.pais)
    const [isModalOpen, setIsModalOpen] = useState(false);

    const WrappedComponent = (props) => {
        const {
            component
        } = props
        // Hacer una copia del componente y asignarle un nuevo onSelect
        const NewComponent = React.cloneElement(component, {
            onSelect: (data) => {
                // Aquí puedes capturar y procesar los datos
                seleccionarRegistro(data);
    
                // Si el componente original tenía un onSelect, lo invocas aquí también
                if (component.props && component.props.onSelect) {
                    component.props.onSelect(data);
                    // if(props.)
                }
            }
        });
    
        return NewComponent;
    }

    const handleCancel = () => {
        setIsModalOpen(false);
      };

      const seleccionarRegistro = (data) => {
        // if(props.onSelect) props.onSelect(data)
        // relacionar(data)
        console.log({ a: data})
        setIsModalOpen(false)
        // setSeleccionado(data)
    }

    const showModalV2 = () => {
        return <div>
            <Modal
            width="80%"
            footer={[]}
            title={TEXT_LANG(botones[slug]?.label, pais)}
            open={isModalOpen} 
            onCancel={handleCancel}
        >
        {component}
        </Modal>
        <Button size="small" onClick={() => setIsModalOpen(true)} style={{ textTransform: "uppercase" }} >{title ? title : "VER DETALLES"}</Button>
        </div>
    }

    const visualizacionTipoModal = () => {
        if(version === "v2") return showModalV2()
        const title = TEXT_LANG(botones[slug]?.label, pais)
        return <div>
            <Modal
            width="80%"
            footer={[]}
            title={TEXT_LANG(botones[slug]?.label, pais)}
            open={isModalOpen} 
            onCancel={handleCancel}
        >
        <WrappedComponent component={component} />
        </Modal>
        <Button style={{ textTransform: "uppercase" }} onClick={() => setIsModalOpen(true)} >{ title ? title : slug }</Button>
        </div>
    }

    const visualizarDatos = () => {
        if(typeView==="modal") return visualizacionTipoModal()
        return component
    }

    return <div>
        {visualizarDatos()}
    </div>
}

export default ModalPersonalizado